import React from 'react';

const Icon = ({ name, className }) => {
    return <i className={`icon ${className || ''} ri ri-${name}`}></i>;
};

export default Icon;
